import Container from '@/components/Container';

export default function PostDisclaimer() {
  return (
    <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-4 bg-white rounded-lg shadow p-4 lg:p-6">
      <div>
        <svg
          className="w-6 h-6 text-yellow-400"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div className="text-sm lg:text-xs text-gray-500">
        <p className="leading-relaxed">
          Este blog proporciona información general y discusión sobre el marco
          de trabajo Scrum, Agile y temas relacionados.
        </p>
      </div>
    </div>
  );
}
